// import React, { useState, useEffect, useRef } from 'react';

// const Team = () => {
//   const [hoveredTeamMember, setHoveredTeamMember] = useState(null);
//   const [activeFAQ, setActiveFAQ] = useState(null);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [activeService, setActiveService] = useState(0);
//   const testimonialRef = useRef(null);
//   const [isMobile, setIsMobile] = useState(false);
  
//   // Chatbot states
//   const [isChatOpen, setIsChatOpen] = useState(false);
//   const [chatMessages, setChatMessages] = useState([]);
//   const [chatInput, setChatInput] = useState('');
//   const [leadCaptured, setLeadCaptured] = useState(false);
//   const [awaitingLeadInfo, setAwaitingLeadInfo] = useState(false);
//   const [leadStep, setLeadStep] = useState(0);
//   const [userData, setUserData] = useState({ name: '', phone: '', city: '' });
//   const [messageCount, setMessageCount] = useState(0);
//   const [quickReplies, setQuickReplies] = useState([]);
//   const [chatbotHover, setChatbotHover] = useState(false);

//   // Check if mobile on mount and resize
//   useEffect(() => {
//     const checkMobile = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };
    
//     checkMobile();
//     window.addEventListener('resize', checkMobile);
    
//     return () => window.removeEventListener('resize', checkMobile);
//   }, []);

//   // Initialize chat when opened
//   useEffect(() => {
//     if (isChatOpen && chatMessages.length === 0) {
//       initChat();
//     }
//   }, [isChatOpen]);

//   // Testimonials data with auto-scroll
//   const testimonials = [
//     {
//       id: 1,
//       name: "Vinit Tembare",
//       role: "Homeowner, Nagpur",
//       text: "I recently installed solar panels from Blue Sky Energy and couldn't be happier with the results. My electricity bills have reduced by 80%! The team was professional, efficient, and guided me through every step.",
//       rating: 5,
//       image:  require('./images/customer6.jpeg'),
//     },
//     {
//       id: 2,
//       name: "Sangita Banait",
//       role: "Business Owner, Akola",
//       text: "As a small business owner, switching to solar was the best decision I made. Blue Sky Energy's commercial solution helped me save ₹3.5 lakhs annually. Their after-sales service is exceptional!",
//       rating: 5,
//       image:  require('./images/customer5.jpeg'),
//     },
//     {
//       id: 3,
//       name: "Sumit Hedaoo",
//       role: "Factory Manager, Amravati",
//       text: "Our manufacturing plant reduced energy costs by 68% after installing Blue Sky Energy's 500kW system. The ROI was faster than expected, and we're proud to be more environmentally responsible.",
//       rating: 5,
//       image:  require('./images/customer4.jpeg'),
//     },
//     {
//       id: 4,
//       name: "Chaksuka Kindarle",
//       role: "Residential Client, Bhandara",
//       text: "The solar installation process was seamless. From consultation to activation, Blue Sky Energy team was transparent and professional. We're now generating surplus energy that we sell back to the grid!",
//       rating: 5,
//       image:  require('./images/customer3.jpeg'),
//     }
//   ];

//   // Team members data
//   const teamMembers = [
//     {
//       id: 1,
//       name: "Lokesh Karemore",
//       role: "Solar Technology Expert",
//       bio: "15+ years in renewable energy. Specializes in photovoltaic systems and energy storage solutions.",
//       image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
//       expertise: ["PV Systems", "Battery Storage", "Grid Integration"]
//     },
//     {
//       id: 2,
//       name: "Anikesh Karemore",
//       role: "Project Director",
//       bio: "Leads our largest commercial and industrial solar projects. 12 years in renewable energy sector.",
//       image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
//       expertise: ["Project Management", "Commercial Installations", "Client Relations"]
//     },
//     {
//       id: 3,
//       name: "Akshay Sahare",
//       role: "Installation Manager",
//       bio: "Oversees all residential and commercial installations. Certified solar installer with 10+ years experience.",
//       image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
//       expertise: ["Installation", "Quality Control", "Safety Standards"]
//     },
//   ];

//   // FAQ Data
//   const faqs = [
//     {
//       id: 1,
//       question: "How long does solar panel installation take?",
//       answer: "Typically, residential installations take 1-3 days, while commercial projects may take 2-4 weeks depending on scale. We complete most installations within the promised timeframe with minimal disruption.",
//       category: "Installation"
//     },
//     {
//       id: 2,
//       question: "Do solar panels work during monsoon/cloudy days?",
//       answer: "Yes! Modern solar panels work at 10-25% efficiency even on cloudy days. During monsoon, you'll still generate significant power, and our systems include battery storage for continuous supply.",
//       category: "Performance"
//     },
//     {
//       id: 3,
//       question: "What maintenance do solar panels require?",
//       answer: "Solar panels require minimal maintenance. We recommend cleaning them twice a year and annual professional inspection. Our maintenance packages start at ₹2,999/year.",
//       category: "Maintenance"
//     },
//     {
//       id: 4,
//       question: "Are there government subsidies available?",
//       answer: "Yes! You can avail up to 40% subsidy on residential solar installations through government schemes. We help you with all documentation and approval processes.",
//       category: "Financial"
//     },
//     {
//       id: 5,
//       question: "What is the lifespan of solar panels?",
//       answer: "Most solar panels come with 25-year performance warranties and can last 30+ years with proper maintenance. We use Tier-1 panels with the longest warranties in the industry.",
//       category: "Performance"
//     }
//   ];

//   // Services Data
//   const services = [
//     {
//       id: 1,
//       title: "Residential Solar Solutions",
//       description: "Complete solar systems for homes, apartments, and villas with net metering.",
//       icon: "🏠",
//       image: require('./images/service (2).jpg')
//     },
//     {
//       id: 2,
//       title: "Commercial Solar Systems",
//       description: "Custom solar solutions for businesses, factories, and commercial complexes.",
//       icon: "🏢",
//       image: require('./images/service.jpg')
//     },
//     {
//       id: 3,
//       title: "Solar Water Pumping",
//       description: "Agricultural and domestic solar water pumping systems for remote areas.",
//       icon: "💧",
//       image: require('./images/service3.jpg')
//     },
//   ];

//   // Process Steps
//   const processSteps = [
//     {
//       id: 1,
//       title: "Consultation & Assessment",
//       description: "Free site survey and energy analysis",
//       icon: "📞"
//     },
//     {
//       id: 2,
//       title: "Custom Design & Proposal",
//       description: "Tailored solar system design and quotation",
//       icon: "📐"
//     },
//     {
//       id: 3,
//       title: "Installation",
//       description: "Professional installation by certified technicians",
//       icon: "🔧"
//     },
//     {
//       id: 4,
//       title: "Activation & Support",
//       description: "System activation and ongoing maintenance",
//       icon: "⚡"
//     }
//   ];

//   // Auto-scroll testimonials
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % testimonials.length);
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [testimonials.length]);

//   // Auto-rotate services
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setActiveService((prev) => (prev + 1) % services.length);
//     }, 4000);
//     return () => clearInterval(interval);
//   }, [services.length]);

//   // Chatbot functions
//   const initChat = () => {
//     addChatMessage("Hi 👋 Welcome to Blue Sky Energy! How can we help you with our team and services today?", 'bot');
//     setTimeout(() => {
//       addChatMessage("Choose an option to get started:", 'bot');
//       setQuickReplies([
//         "👥 Meet Our Team", 
//         "🛠️ Our Services", 
//         "📞 Contact Experts",
//         "💬 Customer Support"
//       ]);
//     }, 800);
//   };

//   const addChatMessage = (text, sender) => {
//     const time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//     const newMessage = {
//       text,
//       sender,
//       time,
//       id: Date.now()
//     };
//     setChatMessages(prev => [...prev, newMessage]);
//     if (sender === 'user') {
//       setMessageCount(prev => prev + 1);
//     }
//   };

//   // Keyword Logic for Team/Services
//   const matchKeywords = (input) => {
//     const text = input.toLowerCase();
//     if (text.includes('team') || text.includes('expert') || text.includes('staff')) {
//       return "👥 Our Expert Team\n\n• Lokesh Karemore - Solar Technology Expert\n• Anikesh Karemore - Project Director\n• Akshay Sahare - Installation Manager\n\n5000+ projects completed, 98% satisfaction rate. Want to know more about our team?";
//     }
//     if (text.includes('service') || text.includes('solution') || text.includes('offer')) {
//       return "🛠️ Our Services\n\n• Residential Solar Solutions (Homes & Villas)\n• Commercial Solar Systems (Businesses & Factories)\n• Solar Water Pumping (Agriculture)\n• Industrial Solar Projects\n• Maintenance & Support\n\nWhich service are you interested in?";
//     }
//     if (text.includes('contact') || text.includes('call') || text.includes('talk')) {
//       return "📞 Contact Our Experts\n\n• Call: +91 80879 32436\n• Email: info@blueskyenergy.in\n• Hours: Sun-Sat 9:30 AM - 9:00 PM\n• Address: Plot.No 62A, Umred Rd, Nagpur\n\nWant to schedule a free consultation?";
//     }
//     if (text.includes('support') || text.includes('help') || text.includes('assistance')) {
//       return "💬 Customer Support\n\n• 24/7 Technical Support\n• Annual Maintenance Plans\n• Emergency Repairs\n• Performance Monitoring\n• Warranty Claims\n\nHow can we assist you today?";
//     }
//     if (text.includes('installation') || text.includes('install') || text.includes('process')) {
//       return "🔧 Our 4-Step Process\n\n1. Free Consultation & Assessment\n2. Custom Design & Proposal\n3. Professional Installation\n4. Activation & Ongoing Support\n\nAll projects completed within promised timeframe. Want process details?";
//     }
//     if (text.includes('experience') || text.includes('year') || text.includes('expertise')) {
//       return "🏆 Our Expertise\n\n• 10+ Years Experience\n• 5000+ Projects Completed\n• 98% Customer Satisfaction\n• Certified Solar Installers\n• Tier-1 Solar Panels\n\nWe guarantee on-time completion and 100% satisfaction!";
//     }
//     if (text.includes('testimonial') || text.includes('review') || text.includes('feedback')) {
//       return "⭐ Customer Feedback\n\n\"My electricity bills reduced by 80%!\" - Vinit Tembare, Nagpur\n\"Saved ₹3.5 lakhs annually!\" - Sangita Banait, Akola\n\"Professional team, seamless installation!\" - Sumit Hedaoo, Amravati\n\nWant to see more testimonials?";
//     }
//     if (text.includes('faq') || text.includes('question') || text.includes('answer')) {
//       return "❓ Common Questions\n\n• Installation takes 1-3 days\n• Works on cloudy days (10-25% efficiency)\n• Minimal maintenance required\n• 40% government subsidies available\n• 25+ years lifespan\n\nHave a specific question?";
//     }
//     return "I understand you're interested in our team and services! I can help you connect with our experts, learn about our services, get installation details, or answer any questions you have.";
//   };

//   // Lead Capture Logic
//   const handleLeadCapture = (input) => {
//     if (leadStep === 0) {
//       setUserData(prev => ({ ...prev, name: input }));
//       setLeadStep(1);
//       addChatMessage(`Nice to meet you, ${input}! 😊\n\nCould you please share your phone number?`, 'bot');
//     } else if (leadStep === 1) {
//       setUserData(prev => ({ ...prev, phone: input }));
//       setLeadStep(2);
//       addChatMessage("Great! And which city are you from?", 'bot');
//     } else if (leadStep === 2) {
//       setUserData(prev => ({ ...prev, city: input }));
//       setLeadCaptured(true);
//       setAwaitingLeadInfo(false);
//       saveLead({ ...userData, city: input });
//       addChatMessage(`Perfect! Thank you ${userData.name}! ✅\n\nOur team expert will contact you within 24 hours. You'll be connected with Lokesh, Anikesh, or Akshay based on your needs.`, 'bot');
//     }
//   };

//   const saveLead = (data) => {
//     const leadId = `lead_${Date.now()}`;
//     localStorage.setItem(leadId, JSON.stringify({...data, timestamp: new Date()}));
//     console.log("Team Page Lead Saved:", data);
//   };

//   const handleChatSend = () => {
//     const text = chatInput.trim();
//     if (!text) return;

//     addChatMessage(text, 'user');
//     setChatInput('');
//     setQuickReplies([]);

//     setTimeout(() => {
//       if (awaitingLeadInfo) {
//         handleLeadCapture(text);
//       } else {
//         const response = matchKeywords(text);
//         addChatMessage(response, 'bot');

//         // Trigger Lead Capture after 2 interactions
//         if (!leadCaptured && messageCount >= 1) {
//           setTimeout(() => {
//             addChatMessage("I'd love to connect you with our team! 📋\n\nCan I get your name to assist you better?", 'bot');
//             setAwaitingLeadInfo(true);
//           }, 1500);
//         }
//       }
//     }, 600);
//   };

//   const handleQuickReply = (option) => {
//     setChatInput(option);
//     setTimeout(() => {
//       handleChatSend();
//     }, 100);
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       handleChatSend();
//     }
//   };

//   // Responsive Styles
//   const getResponsiveStyle = (desktopStyle, mobileStyle) => {
//     return isMobile ? { ...desktopStyle, ...mobileStyle } : desktopStyle;
//   };

//   const styles = {
//     container: {
//       fontFamily: "Cambria, serif",
//       backgroundColor: '#ffffff',
//       minHeight: '100vh',
//       color: '#123249',
//       overflowX: 'hidden',
//       position: 'relative',
//       width: '100%'
//     },
    
//     // Chatbot Styles - Blue Theme
//     chatbotContainer: {
//       position: 'fixed',
//       bottom: isMobile ? '10px' : '20px',
//       right: isMobile ? '10px' : '20px',
//       zIndex: '9999',
//       fontFamily: "Cambria, serif"
//     },
//     chatToggleBtn: {
//       position: 'fixed',
//       bottom: isMobile ? '10px' : '20px',
//       right: isMobile ? '10px' : '20px',
//       width: isMobile ? '50px' : '60px',
//       height: isMobile ? '50px' : '60px',
//       borderRadius: '50%',
//       background: 'linear-gradient(135deg, #447793, #2D5A74)',
//       color: 'white',
//       border: 'none',
//       fontSize: isMobile ? '20px' : '24px',
//       cursor: 'pointer',
//       boxShadow: '0 8px 30px rgba(68, 119, 147, 0.3)',
//       transition: 'all 0.3s ease',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       zIndex: '10000',
//       padding: '0',
//       animation: chatbotHover ? 'pulse 0.5s infinite' : 'pulse 2s infinite'
//     },
//     chatWindow: {
//       position: 'fixed',
//       bottom: isMobile ? '70px' : '90px',
//       right: isMobile ? '10px' : '20px',
//       width: isMobile ? 'calc(100vw - 20px)' : '380px',
//       maxWidth: isMobile ? 'calc(100vw - 20px)' : 'calc(100vw - 40px)',
//       height: isMobile ? '60vh' : '550px',
//       maxHeight: isMobile ? '60vh' : '70vh',
//       background: 'white',
//       borderRadius: '16px',
//       boxShadow: '0 10px 40px rgba(6, 18, 33, 0.15)',
//       display: 'flex',
//       flexDirection: 'column',
//       overflow: 'hidden',
//       zIndex: '9999',
//       transition: 'all 0.3s ease',
//       opacity: isChatOpen ? '1' : '0',
//       visibility: isChatOpen ? 'visible' : 'hidden',
//       transform: isChatOpen ? 'translateY(0)' : 'translateY(20px)',
//       border: '1px solid #DDE8ED'
//     },
//     chatHeader: {
//       background: 'linear-gradient(135deg, #447793, #2D5A74)',
//       color: 'white',
//       padding: isMobile ? '12px' : '16px',
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
//     },
//     headerInfo: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: isMobile ? '8px' : '12px'
//     },
//     headerIcon: {
//       background: 'rgba(255, 255, 255, 0.2)',
//       padding: isMobile ? '8px' : '10px',
//       borderRadius: '50%',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       width: isMobile ? '35px' : '40px',
//       height: isMobile ? '35px' : '40px',
//       fontSize: isMobile ? '16px' : '18px'
//     },
//     chatHeaderTitle: {
//       margin: '0',
//       fontSize: isMobile ? '14px' : '16px',
//       fontWeight: '600',
//       lineHeight: '1.2',
//       color: 'white'
//     },
//     chatHeaderSubtitle: {
//       margin: '0',
//       fontSize: isMobile ? '10px' : '12px',
//       opacity: '0.9',
//       lineHeight: '1.2',
//       color: '#DDE8ED'
//     },
//     closeChatBtn: {
//       background: 'none',
//       border: 'none',
//       color: 'white',
//       cursor: 'pointer',
//       fontSize: isMobile ? '16px' : '18px',
//       padding: '5px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       transition: 'opacity 0.2s'
//     },
//     quickReplies: {
//       padding: isMobile ? '8px' : '12px',
//       display: 'flex',
//       flexWrap: 'wrap',
//       gap: isMobile ? '6px' : '8px',
//       background: '#DDE8ED',
//       borderBottom: '1px solid #DDE8ED',
//       maxHeight: isMobile ? '80px' : 'none',
//       overflowY: 'auto'
//     },
//     replyBtn: {
//       background: 'white',
//       border: '1px solid #447793',
//       color: '#123249',
//       padding: isMobile ? '6px 12px' : '8px 16px',
//       borderRadius: '20px',
//       fontSize: isMobile ? '12px' : '13px',
//       cursor: 'pointer',
//       transition: 'all 0.2s ease',
//       whiteSpace: 'nowrap',
//       fontWeight: '500',
//       fontFamily: "Cambria, serif",
//       flexShrink: '0'
//     },
//     chatMessages: {
//       flex: '1',
//       padding: isMobile ? '12px' : '16px',
//       background: '#DDE8ED',
//       overflowY: 'auto',
//       display: 'flex',
//       flexDirection: 'column',
//       gap: isMobile ? '8px' : '12px'
//     },
//     message: {
//       maxWidth: isMobile ? '90%' : '80%',
//       padding: isMobile ? '10px 12px' : '12px 16px',
//       borderRadius: '18px',
//       fontSize: isMobile ? '13px' : '14px',
//       lineHeight: '1.5',
//       whiteSpace: 'pre-line',
//       wordWrap: 'break-word',
//       position: 'relative',
//       animation: 'fadeIn 0.3s ease'
//     },
//     botMessage: {
//       background: 'white',
//       alignSelf: 'flex-start',
//       borderBottomLeftRadius: '4px',
//       boxShadow: '0 2px 8px rgba(6, 18, 33, 0.08)',
//       color: '#123249',
//       border: '1px solid #DDE8ED'
//     },
//     userMessage: {
//       background: 'linear-gradient(135deg, #447793, #2D5A74)',
//       color: 'white',
//       alignSelf: 'flex-end',
//       borderBottomRightRadius: '4px'
//     },
//     messageTime: {
//       fontSize: isMobile ? '10px' : '11px',
//       marginTop: '6px',
//       display: 'block',
//       opacity: '0.7'
//     },
//     chatInputArea: {
//       padding: isMobile ? '12px' : '16px',
//       borderTop: '1px solid #DDE8ED',
//       background: 'white'
//     },
//     inputWrapper: {
//       display: 'flex',
//       gap: isMobile ? '8px' : '10px',
//       marginBottom: isMobile ? '6px' : '8px'
//     },
//     chatInput: {
//       flex: '1',
//       padding: isMobile ? '10px 14px' : '12px 16px',
//       border: '1px solid #DDE8ED',
//       borderRadius: '25px',
//       outline: 'none',
//       fontSize: isMobile ? '13px' : '14px',
//       fontFamily: "Cambria, serif",
//       transition: 'border-color 0.2s',
//       color: '#123249'
//     },
//     sendBtn: {
//       background: 'linear-gradient(135deg, #447793, #2D5A74)',
//       color: 'white',
//       border: 'none',
//       width: isMobile ? '40px' : '45px',
//       height: isMobile ? '40px' : '45px',
//       borderRadius: '50%',
//       cursor: 'pointer',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       fontSize: isMobile ? '14px' : '16px',
//       transition: 'all 0.2s ease',
//       padding: '0'
//     },
//     footerText: {
//       textAlign: 'center',
//       fontSize: isMobile ? '10px' : '11px',
//       color: '#2D5A74',
//       margin: '0'
//     },
    
//     // Hero Section - Blue Theme
//     heroSection: {
//       background: 'linear-gradient(rgba(18, 50, 73, 0.95), rgba(45, 90, 116, 0.95))',
//       color: 'white',
//       padding: isMobile ? '80px 20px 40px' : '120px 20px 80px',
//       textAlign: 'center',
//       position: 'relative',
//       overflow: 'hidden'
//     },
//     heroTitle: {
//       fontSize: isMobile ? '2rem' : '3.5rem',
//       fontWeight: '800',
//       marginBottom: isMobile ? '15px' : '20px',
//       textShadow: '2px 2px 4px rgba(6, 18, 33, 0.1)',
//       lineHeight: isMobile ? '1.2' : '1.3',
//       color: 'white'
//     },
//     heroSubtitle: {
//       fontSize: isMobile ? '1rem' : '1.3rem',
//       maxWidth: '800px',
//       margin: '0 auto',
//       marginBottom: isMobile ? '30px' : '40px',
//       opacity: '0.95',
//       lineHeight: '1.6',
//       padding: isMobile ? '0 10px' : '0',
//       color: '#DDE8ED'
//     },
//     heroStats: {
//       display: 'flex',
//       justifyContent: 'center',
//       gap: isMobile ? '20px' : '60px',
//       marginTop: isMobile ? '30px' : '40px',
//       flexWrap: 'wrap'
//     },
//     statItem: {
//       textAlign: 'center',
//       flex: isMobile ? '1 0 40%' : 'none',
//       marginBottom: isMobile ? '15px' : '0'
//     },
//     statNumber: {
//       fontSize: isMobile ? '2rem' : '3rem',
//       fontWeight: '800',
//       marginBottom: '5px',
//       color: '#DDE8ED'
//     },
//     statLabel: {
//       fontSize: isMobile ? '0.9rem' : '1rem',
//       opacity: '0.9',
//       color: 'white'
//     },
    
//     // Main Content Container
//     mainContent: {
//       maxWidth: '1200px',
//       margin: '0 auto',
//       padding: isMobile ? '40px 20px' : '60px 20px'
//     },
    
//     // Section Headers - Blue Theme
//     sectionHeader: {
//       textAlign: 'center',
//       marginBottom: isMobile ? '40px' : '60px',
//       padding: isMobile ? '0 10px' : '0'
//     },
//     sectionTitle: {
//       fontSize: isMobile ? '1.8rem' : '2.5rem',
//       fontWeight: '800',
//       color: '#123249',
//       marginBottom: isMobile ? '10px' : '15px',
//       lineHeight: isMobile ? '1.2' : '1.3'
//     },
//     sectionSubtitle: {
//       fontSize: isMobile ? '1rem' : '1.1rem',
//       color: '#2D5A74',
//       maxWidth: '800px',
//       margin: '0 auto',
//       lineHeight: '1.6',
//       padding: isMobile ? '0 10px' : '0'
//     },
    
//     // About Section - Blue Theme
//     aboutSection: {
//       backgroundColor: '#DDE8ED',
//       padding: isMobile ? '40px 20px' : '80px 20px',
//       marginTop: isMobile ? '20px' : '40px'
//     },
//     aboutContainer: {
//       maxWidth: '1200px',
//       margin: '0 auto',
//       display: 'grid',
//       gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//       gap: isMobile ? '40px' : '60px',
//       alignItems: 'center'
//     },
//     aboutContent: {
//       paddingRight: isMobile ? '0' : '40px'
//     },
//     aboutTitle: {
//       fontSize: isMobile ? '1.8rem' : '2.2rem',
//       fontWeight: '800',
//       color: '#123249',
//       marginBottom: isMobile ? '15px' : '20px'
//     },
//     aboutText: {
//       color: '#2D5A74',
//       fontSize: isMobile ? '0.95rem' : '1rem',
//       lineHeight: '1.7',
//       marginBottom: isMobile ? '20px' : '25px'
//     },
//     featuresList: {
//       display: 'grid',
//       gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//       gap: isMobile ? '15px' : '20px',
//       marginTop: isMobile ? '20px' : '30px'
//     },
//     featureItem: {
//       display: 'flex',
//       alignItems: 'flex-start',
//       gap: isMobile ? '10px' : '15px'
//     },
//     featureIcon: {
//       color: '#447793',
//       fontSize: isMobile ? '1.2rem' : '1.5rem'
//     },
//     featureText: {
//       color: '#2D5A74',
//       fontSize: isMobile ? '0.9rem' : '0.95rem',
//       lineHeight: '1.6'
//     },
    
//     // Team Section - Blue Theme
//     teamSection: {
//       padding: isMobile ? '40px 20px' : '80px 20px'
//     },
//     teamGrid: {
//       display: 'grid',
//       gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))',
//       gap: isMobile ? '20px' : '30px',
//       marginTop: isMobile ? '30px' : '40px'
//     },
//     teamCard: {
//       backgroundColor: 'white',
//       borderRadius: isMobile ? '10px' : '15px',
//       overflow: 'hidden',
//       boxShadow: '0 10px 30px rgba(6, 18, 33, 0.08)',
//       transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
//       position: 'relative',
//       cursor: 'pointer',
//       border: '1px solid #DDE8ED'
//     },
//     teamImage: {
//       width: '100%',
//       height: isMobile ? '250px' : '300px',
//       objectFit: 'cover',
//       transition: 'transform 0.5s ease'
//     },
//     teamContent: {
//       padding: isMobile ? '20px' : '25px'
//     },
//     teamName: {
//       fontSize: isMobile ? '1.2rem' : '1.4rem',
//       fontWeight: '700',
//       color: '#123249',
//       marginBottom: isMobile ? '6px' : '8px'
//     },
//     teamRole: {
//       color: '#447793',
//       fontSize: isMobile ? '0.85rem' : '0.95rem',
//       fontWeight: '600',
//       marginBottom: isMobile ? '12px' : '15px'
//     },
//     teamBio: {
//       color: '#2D5A74',
//       fontSize: isMobile ? '0.85rem' : '0.9rem',
//       lineHeight: '1.6',
//       marginBottom: isMobile ? '15px' : '20px'
//     },
//     expertiseContainer: {
//       display: 'flex',
//       flexWrap: 'wrap',
//       gap: '8px',
//       marginTop: isMobile ? '12px' : '15px'
//     },
//     expertiseTag: {
//       backgroundColor: '#DDE8ED',
//       color: '#123249',
//       padding: isMobile ? '3px 10px' : '4px 12px',
//       borderRadius: '15px',
//       fontSize: isMobile ? '0.7rem' : '0.75rem',
//       fontWeight: '500'
//     },
    
//     // Process Section - Blue Theme
//     processSection: {
//       backgroundColor: '#DDE8ED',
//       padding: isMobile ? '40px 20px' : '80px 20px'
//     },
//     processContainer: {
//       maxWidth: '1200px',
//       margin: '0 auto'
//     },
//     processStepsContainer: {
//       display: isMobile ? 'flex' : 'flex',
//       flexDirection: isMobile ? 'column' : 'row',
//       justifyContent: 'space-between',
//       alignItems: 'flex-start',
//       marginTop: isMobile ? '30px' : '50px',
//       position: 'relative',
//       gap: isMobile ? '30px' : '0'
//     },
//     processStep: {
//       textAlign: 'center',
//       flex: isMobile ? '1' : '1',
//       padding: isMobile ? '0' : '0 20px',
//       position: 'relative'
//     },
//     stepIcon: {
//       width: isMobile ? '60px' : '80px',
//       height: isMobile ? '60px' : '80px',
//       backgroundColor: '#447793',
//       borderRadius: '50%',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       margin: '0 auto',
//       marginBottom: isMobile ? '15px' : '20px',
//       fontSize: isMobile ? '1.5rem' : '2rem',
//       color: 'white',
//       boxShadow: '0 10px 20px rgba(68, 119, 147, 0.3)'
//     },
//     stepTitle: {
//       fontSize: isMobile ? '1.1rem' : '1.2rem',
//       fontWeight: '700',
//       color: '#123249',
//       marginBottom: isMobile ? '8px' : '10px'
//     },
//     stepDescription: {
//       color: '#2D5A74',
//       fontSize: isMobile ? '0.85rem' : '0.9rem',
//       lineHeight: '1.6'
//     },
    
//     // Services Section - Blue Theme
//     servicesSection: {
//       padding: isMobile ? '40px 20px' : '80px 20px',
//       backgroundColor: '#ffffff'
//     },
//     servicesGrid: {
//       display: 'grid',
//       gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
//       gap: isMobile ? '20px' : '30px',
//       marginTop: isMobile ? '30px' : '40px'
//     },
//     serviceCard: {
//       backgroundColor: 'white',
//       borderRadius: isMobile ? '10px' : '15px',
//       overflow: 'hidden',
//       boxShadow: '0 10px 30px rgba(6, 18, 33, 0.08)',
//       transition: 'all 0.4s ease',
//       position: 'relative',
//       cursor: 'pointer',
//       border: '3px solid transparent',
//     },
//     serviceImage: {
//       width: '100%',
//       height: isMobile ? '180px' : '200px',
//       objectFit: 'cover',
//       transition: 'transform 0.5s ease'
//     },
//     serviceContent: {
//       padding: isMobile ? '20px' : '25px'
//     },
//     serviceIcon: {
//       fontSize: isMobile ? '2rem' : '2.5rem',
//       marginBottom: isMobile ? '12px' : '15px'
//     },
//     serviceTitle: {
//       fontSize: isMobile ? '1.2rem' : '1.3rem',
//       fontWeight: '700',
//       color: '#123249',
//       marginBottom: isMobile ? '8px' : '10px'
//     },
//     serviceDescription: {
//       color: '#2D5A74',
//       fontSize: isMobile ? '0.9rem' : '0.95rem',
//       lineHeight: '1.6',
//       marginBottom: isMobile ? '15px' : '20px'
//     },
//     learnMore: {
//       color: '#447793',
//       fontWeight: '600',
//       textDecoration: 'none',
//       fontSize: isMobile ? '0.9rem' : '0.95rem',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '5px',
//       transition: 'all 0.3s ease'
//     },
    
//     // Testimonials Section - Blue Theme
//     testimonialsSection: {
//       background: 'linear-gradient(rgba(18, 50, 73, 0.95), rgba(45, 90, 116, 0.95))',
//       padding: isMobile ? '40px 20px' : '80px 20px',
//       color: 'white'
//     },
//     testimonialSlider: {
//       maxWidth: '800px',
//       margin: isMobile ? '30px auto 0' : '40px auto 0',
//       position: 'relative',
//       minHeight: isMobile ? '350px' : '300px'
//     },
//     testimonialCard: {
//       backgroundColor: '#ffffff',
//       borderRadius: isMobile ? '10px' : '15px',
//       padding: isMobile ? '25px' : '40px',
//       textAlign: 'center',
//       minHeight: isMobile ? '350px' : '300px',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'center',
//       alignItems: 'center',
//       border: '1px solid #DDE8ED'
//     },
//     testimonialRating: {
//       fontSize: isMobile ? '1.3rem' : '1.5rem',
//       color: '#447793',
//       marginBottom: isMobile ? '15px' : '20px'
//     },
//     testimonialText: {
//       fontSize: isMobile ? '1rem' : '1.1rem',
//       lineHeight: '1.7',
//       marginBottom: isMobile ? '25px' : '30px',
//       color: '#123249',
//       fontStyle: 'italic'
//     },
//     testimonialAuthor: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: isMobile ? '12px' : '15px',
//       flexDirection: isMobile ? 'column' : 'row',
//       textAlign: isMobile ? 'center' : 'left'
//     },
//     authorImage: {
//       width: isMobile ? '50px' : '60px',
//       height: isMobile ? '50px' : '60px',
//       borderRadius: '50%',
//       objectFit: 'cover',
//       border: '3px solid #447793'
//     },
//     authorInfo: {
//       textAlign: isMobile ? 'center' : 'left'
//     },
//     authorName: {
//       fontSize: isMobile ? '1rem' : '1.1rem',
//       fontWeight: '700',
//       marginBottom: '5px',
//       color: '#123249'
//     },
//     authorRole: {
//       color: '#2D5A74',
//       fontSize: isMobile ? '0.85rem' : '0.9rem',
//       opacity: '0.8'
//     },
//     sliderDots: {
//       display: 'flex',
//       justifyContent: 'center',
//       gap: isMobile ? '8px' : '10px',
//       marginTop: isMobile ? '25px' : '30px'
//     },
//     dot: {
//       width: isMobile ? '10px' : '12px',
//       height: isMobile ? '10px' : '12px',
//       borderRadius: '50%',
//       backgroundColor: '#4a5568',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease'
//     },
//     activeDot: {
//       backgroundColor: '#447793',
//       transform: 'scale(1.2)'
//     },
    
//     // FAQ Section - Blue Theme
//     faqSection: {
//       padding: isMobile ? '40px 20px' : '80px 20px',
//       backgroundColor: '#ffffff'
//     },
//     faqContainer: {
//       maxWidth: '800px',
//       margin: isMobile ? '30px auto 0' : '40px auto 0'
//     },
//     faqItem: {
//       backgroundColor: '#DDE8ED',
//       borderRadius: isMobile ? '8px' : '10px',
//       marginBottom: isMobile ? '12px' : '15px',
//       overflow: 'hidden',
//       border: '2px solid #DDE8ED',
//       transition: 'all 0.3s ease'
//     },
//     faqQuestion: {
//       padding: isMobile ? '15px 20px' : '20px 25px',
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       cursor: 'pointer',
//       backgroundColor: 'white',
//       flexDirection: isMobile ? 'column' : 'row',
//       gap: isMobile ? '10px' : '0',
//       alignItems: isMobile ? 'flex-start' : 'center'
//     },
//     questionText: {
//       fontSize: isMobile ? '1rem' : '1.1rem',
//       fontWeight: '600',
//       color: '#123249',
//       display: 'flex',
//       alignItems: 'center',
//       gap: isMobile ? '10px' : '15px',
//       flexWrap: 'wrap'
//     },
//     questionCategory: {
//       backgroundColor: '#DDE8ED',
//       color: '#123249',
//       padding: isMobile ? '3px 10px' : '4px 12px',
//       borderRadius: '15px',
//       fontSize: isMobile ? '0.75rem' : '0.8rem',
//       fontWeight: '600'
//     },
//     faqAnswer: {
//       padding: '0 25px',
//       maxHeight: '0',
//       overflow: 'hidden',
//       transition: 'all 0.3s ease',
//       color: '#2D5A74',
//       lineHeight: '1.6',
//       fontSize: isMobile ? '0.9rem' : '1rem'
//     },
//     faqAnswerOpen: {
//       padding: isMobile ? '15px 20px' : '20px 25px',
//       maxHeight: '500px'
//     },
    
//     // Mobile-specific styles
//     mobileHidden: {
//       display: isMobile ? 'none' : 'block'
//     },
//     mobileOnly: {
//       display: isMobile ? 'block' : 'none'
//     }
//   };

//   return (
//     <div style={styles.container}>
//       {/* Hero Section - Blue Theme */}
//       <section style={styles.heroSection}>
//         <h1 style={styles.heroTitle}>POWERING FUTURES, BUILDING TRUST</h1>
//         <p style={styles.heroSubtitle}>
//           We Do Everything Solar For Everyone. With over 10 years of experience in renewable energy, 
//           we've helped thousands of homes and businesses transition to clean, affordable solar power.
//         </p>
        
//         <div style={styles.heroStats}>
//           <div style={styles.statItem}>
//             <div style={styles.statNumber}>10+</div>
//             <div style={styles.statLabel}>Years Experience</div>
//           </div>
//           <div style={styles.statItem}>
//             <div style={styles.statNumber}>5000+</div>
//             <div style={styles.statLabel}>Projects Completed</div>
//           </div>
//           <div style={styles.statItem}>
//             <div style={styles.statNumber}>98%</div>
//             <div style={styles.statLabel}>Client Satisfaction</div>
//           </div>
//           <div style={styles.statItem}>
//             <div style={styles.statNumber}>24/7</div>
//             <div style={styles.statLabel}>Customer Support</div>
//           </div>
//         </div>
//       </section>

//       {/* About Section - Blue Theme */}
//       <section style={styles.aboutSection}>
//         <div style={styles.aboutContainer}>
//           <div style={styles.aboutContent}>
//             <h2 style={styles.aboutTitle}>ABOUT BLUE SKY ENERGY</h2>
//             <h3 style={{
//               ...styles.sectionSubtitle, 
//               textAlign: 'left', 
//               marginBottom: isMobile ? '20px' : '30px',
//               fontSize: isMobile ? '1.1rem' : '1.2rem',
//               fontWeight: '600'
//             }}>
//               Who We Are And What We Stand For
//             </h3>
//             <p style={styles.aboutText}>
//               Our team proudly offers an on-time guarantee and a 100% customer satisfaction guarantee. 
//               It's why we make sure that our licensed solar technicians are highly trained and fully 
//               equipped to meet your diverse solar energy needs.
//             </p>
            
//             <div style={styles.featuresList}>
//               <div style={styles.featureItem}>
//                 <span style={styles.featureIcon}>✓</span>
//                 <span style={styles.featureText}>Residential Solar Solutions</span>
//               </div>
//               <div style={styles.featureItem}>
//                 <span style={styles.featureIcon}>✓</span>
//                 <span style={styles.featureText}>Commercial Solar Systems</span>
//               </div>
//               <div style={styles.featureItem}>
//                 <span style={styles.featureIcon}>✓</span>
//                 <span style={styles.featureText}>Industrial Solar Projects</span>
//               </div>
//               <div style={styles.featureItem}>
//                 <span style={styles.featureIcon}>✓</span>
//                 <span style={styles.featureText}>Maintenance & Support</span>
//               </div>
//             </div>
//           </div>
          
//           <div>
//             <img 
//               src="https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80"
//               alt="Solar Installation"
//               style={{
//                 width: '100%',
//                 borderRadius: isMobile ? '10px' : '15px',
//                 boxShadow: '0 20px 40px rgba(6, 18, 33, 0.1)',
//                 transition: 'transform 0.5s ease',
//                 transform: hoveredTeamMember === 'about' ? 'scale(1.05)' : 'scale(1)'
//               }}
//               onMouseEnter={() => setHoveredTeamMember('about')}
//               onMouseLeave={() => setHoveredTeamMember(null)}
//             />
//           </div>
//         </div>
//       </section>

//       {/* Team Section - Blue Theme */}
//       <section style={styles.teamSection}>
//         <div style={styles.mainContent}>
//           <div style={styles.sectionHeader}>
//             <h2 style={styles.sectionTitle}>Our Expert Team</h2>
//             <p style={styles.sectionSubtitle}>
//               Meet our team of solar energy experts dedicated to powering your sustainable future
//             </p>
//           </div>
          
//           <div style={styles.teamGrid}>
//             {teamMembers.map(member => (
//               <div 
//                 key={member.id} 
//                 style={{
//                   ...styles.teamCard,
//                   transform: hoveredTeamMember === member.id && !isMobile ? 'translateY(-15px)' : 'translateY(0)',
//                   boxShadow: hoveredTeamMember === member.id && !isMobile ? '0 20px 40px rgba(68, 119, 147, 0.15)' : '0 10px 30px rgba(6, 18, 33, 0.08)'
//                 }}
//                 onMouseEnter={() => !isMobile && setHoveredTeamMember(member.id)}
//                 onMouseLeave={() => !isMobile && setHoveredTeamMember(null)}
//                 onClick={() => isMobile && setHoveredTeamMember(hoveredTeamMember === member.id ? null : member.id)}
//               >
//                 <img 
//                   src={member.image} 
//                   alt={member.name}
//                   style={{
//                     ...styles.teamImage,
//                     transform: hoveredTeamMember === member.id ? 'scale(1.1)' : 'scale(1)'
//                   }}
//                 />
//                 <div style={styles.teamContent}>
//                   <h3 style={styles.teamName}>{member.name}</h3>
//                   <p style={styles.teamRole}>{member.role}</p>
//                   <p style={styles.teamBio}>{member.bio}</p>
//                   <div style={styles.expertiseContainer}>
//                     {member.expertise.map((skill, index) => (
//                       <span key={index} style={styles.expertiseTag}>{skill}</span>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Process Section - Blue Theme */}
//       <section style={styles.processSection}>
//         <div style={styles.processContainer}>
//           <div style={styles.sectionHeader}>
//             <h2 style={styles.sectionTitle}>Our Standard Working Process</h2>
//             <p style={styles.sectionSubtitle}>
//               From consultation to activation, we follow a proven 4-step process for seamless solar installation
//             </p>
//           </div>
          
//           <div style={styles.processStepsContainer}>
//             {processSteps.map(step => (
//               <div key={step.id} style={styles.processStep}>
//                 <div style={styles.stepIcon}>{step.icon}</div>
//                 <h3 style={styles.stepTitle}>{step.title}</h3>
//                 <p style={styles.stepDescription}>{step.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Services Section - Blue Theme */}
//       <section style={styles.servicesSection}>
//         <div style={styles.mainContent}>
//           <div style={styles.sectionHeader}>
//             <h2 style={styles.sectionTitle}>OUR BEST SERVICES</h2>
//             <h3 style={{
//               ...styles.sectionSubtitle, 
//               fontSize: isMobile ? '1.2rem' : '1.4rem', 
//               fontWeight: '700', 
//               marginBottom: '10px',
//               color: '#123249'
//             }}>
//               See Our Solar Services
//             </h3>
//             <p style={styles.sectionSubtitle}>
//               Our team proudly offers an on-time guarantee and a 100% customer satisfaction guarantee. 
//               It's why we make sure that our licensed technicians are highly trained.
//             </p>
//           </div>
          
//           <div style={styles.servicesGrid}>
//             {services.map(service => (
//               <div 
//                 key={service.id} 
//                 style={{
//                   ...styles.serviceCard,
//                   border: activeService === service.id - 1 ? '3px solid #447793' : '3px solid transparent',
//                   transform: hoveredTeamMember === `service-${service.id}` && !isMobile ? 'translateY(-10px)' : 'translateY(0)',
//                   boxShadow: hoveredTeamMember === `service-${service.id}` && !isMobile ? '0 20px 40px rgba(68, 119, 147, 0.15)' : '0 10px 30px rgba(6, 18, 33, 0.08)'
//                 }}
//                 onMouseEnter={() => !isMobile && setHoveredTeamMember(`service-${service.id}`)}
//                 onMouseLeave={() => !isMobile && setHoveredTeamMember(null)}
//               >
//                 <img 
//                   src={service.image} 
//                   alt={service.title}
//                   style={{
//                     ...styles.serviceImage,
//                     transform: hoveredTeamMember === `service-${service.id}` ? 'scale(1.1)' : 'scale(1)'
//                   }}
//                 />
//                 <div style={styles.serviceContent}>
//                   <div style={styles.serviceIcon}>{service.icon}</div>
//                   <h3 style={styles.serviceTitle}>{service.title}</h3>
//                   <p style={styles.serviceDescription}>{service.description}</p>
//                   <a href="#" style={styles.learnMore}>
//                     Learn More →
//                   </a>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Testimonials Section - Blue Theme */}
//       <section style={styles.testimonialsSection}>
//         <div style={styles.mainContent}>
//           <div style={styles.sectionHeader}>
//             <h2 style={{...styles.sectionTitle, color: 'white'}}>TESTIMONIALS</h2>
//             <h3 style={{...styles.sectionSubtitle, color: '#DDE8ED'}}>
//               What People Say About Our Solar Solutions
//             </h3>
//           </div>
          
//           <div style={styles.testimonialSlider}>
//             <div style={styles.testimonialCard} ref={testimonialRef}>
//               <div style={styles.testimonialRating}>
//                 {'★'.repeat(testimonials[currentSlide].rating)}
//               </div>
//               <p style={styles.testimonialText}>
//                 "{testimonials[currentSlide].text}"
//               </p>
//               <div style={styles.testimonialAuthor}>
//                 <img 
//                   src={testimonials[currentSlide].image} 
//                   alt={testimonials[currentSlide].name}
//                   style={styles.authorImage}
//                 />
//                 <div style={styles.authorInfo}>
//                   <h4 style={styles.authorName}>{testimonials[currentSlide].name}</h4>
//                   <p style={styles.authorRole}>{testimonials[currentSlide].role}</p>
//                 </div>
//               </div>
//             </div>
            
//             <div style={styles.sliderDots}>
//               {testimonials.map((_, index) => (
//                 <div
//                   key={index}
//                   style={{
//                     ...styles.dot,
//                     ...(index === currentSlide ? styles.activeDot : {})
//                   }}
//                   onClick={() => setCurrentSlide(index)}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* FAQ Section - Blue Theme */}
//       <section style={styles.faqSection}>
//         <div style={styles.mainContent}>
//           <div style={styles.sectionHeader}>
//             <h2 style={styles.sectionTitle}>FREQUENTLY ASKED QUESTIONS</h2>
//             <h3 style={{
//               ...styles.sectionSubtitle, 
//               fontSize: isMobile ? '1.2rem' : '1.4rem', 
//               fontWeight: '700', 
//               marginBottom: '10px',
//               color: '#123249'
//             }}>
//               You Have Questions, We Have Answers
//             </h3>
//             <p style={styles.sectionSubtitle}>
//               Get answers to the most common questions about solar panel installation, maintenance, 
//               and savings. Can't find your answer? Contact our team directly.
//             </p>
//           </div>
          
//           <div style={styles.faqContainer}>
//             {faqs.map(faq => (
//               <div 
//                 key={faq.id} 
//                 style={{
//                   ...styles.faqItem,
//                   borderColor: activeFAQ === faq.id ? '#447793' : '#DDE8ED'
//                 }}
//               >
//                 <div 
//                   style={styles.faqQuestion}
//                   onClick={() => setActiveFAQ(activeFAQ === faq.id ? null : faq.id)}
//                 >
//                   <div style={styles.questionText}>
//                     <span style={styles.questionCategory}>{faq.category}</span>
//                     {faq.question}
//                   </div>
//                   <div style={{fontSize: isMobile ? '1.2rem' : '1.5rem', color: '#447793'}}>
//                     {activeFAQ === faq.id ? '−' : '+'}
//                   </div>
//                 </div>
//                 <div 
//                   style={{
//                     ...styles.faqAnswer,
//                     ...(activeFAQ === faq.id ? styles.faqAnswerOpen : {})
//                   }}
//                 >
//                   {faq.answer}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Chatbot Component - Blue Theme */}
//       <style>
//         {`
//           @keyframes fadeIn {
//             from { opacity: 0; transform: translateY(10px); }
//             to { opacity: 1; transform: translateY(0); }
//           }
          
//           @keyframes pulse {
//             0% { transform: scale(1); }
//             50% { transform: scale(1.05); }
//             100% { transform: scale(1); }
//           }
          
//           /* Mobile responsiveness fixes */
//           @media (max-width: 768px) {
//             .testimonial-card {
//               min-height: 350px;
//               padding: 20px;
//             }
            
//             .hero-title {
//               font-size: 2rem;
//               padding: 0 10px;
//             }
            
//             .hero-subtitle {
//               font-size: 1rem;
//               padding: 0 15px;
//             }
            
//             .section-title {
//               font-size: 1.8rem;
//             }
            
//             .stat-number {
//               font-size: 1.8rem;
//             }
            
//             .stat-label {
//               font-size: 0.85rem;
//             }
            
//             .hero-stats {
//               gap: 15px;
//             }
            
//             .team-card {
//               margin: 0 10px;
//             }
//           }
          
//           @media (max-width: 480px) {
//             .hero-title {
//               font-size: 1.8rem;
//             }
            
//             .section-title {
//               font-size: 1.6rem;
//             }
            
//             .about-title {
//               font-size: 1.6rem;
//             }
            
//             .faq-question {
//               padding: 12px 15px;
//             }
            
//             .testimonial-text {
//               font-size: 0.95rem;
//             }
//           }
          
//           /* Custom scrollbar for chat */
//           ::-webkit-scrollbar {
//             width: 6px;
//           }
          
//           ::-webkit-scrollbar-track {
//             background: #DDE8ED;
//           }
          
//           ::-webkit-scrollbar-thumb {
//             background: #447793;
//             border-radius: 3px;
//           }
          
//           ::-webkit-scrollbar-thumb:hover {
//             background: #2D5A74;
//           }
          
//           /* Prevent text selection on mobile */
//           * {
//             -webkit-tap-highlight-color: transparent;
//           }
          
//           /* Improve touch targets */
//           button, 
//           a, 
//           .team-card, 
//           .service-card, 
//           .faq-item {
//             cursor: pointer;
//           }
          
//           /* Smooth scrolling */
//           html {
//             scroll-behavior: smooth;
//           }
          
//           /* Hover Effects */
//           .team-card:hover .expertise-tag {
//             background-color: #447793 !important;
//             color: white !important;
//           }
          
//           .service-card:hover .learn-more {
//             color: #2D5A74 !important;
//             gap: 10px !important;
//           }
          
//           .faq-item:hover {
//             border-color: #447793 !important;
//           }
//         `}
//       </style>

//       <div style={styles.chatbotContainer}>
//         {/* Chat Toggle Button */}
//         <button 
//           style={styles.chatToggleBtn}
//           onClick={() => setIsChatOpen(!isChatOpen)}
//           onMouseEnter={() => setChatbotHover(true)}
//           onMouseLeave={() => setChatbotHover(false)}
//         >
//           💬
//         </button>

//         {/* Chat Window */}
//         <div style={styles.chatWindow}>
//           {/* Chat Header */}
//           <div style={styles.chatHeader}>
//             <div style={styles.headerInfo}>
//               <div style={styles.headerIcon}>
//                 👥
//               </div>
//               <div>
//                 <h3 style={styles.chatHeaderTitle}>Blue Sky Energy</h3>
//                 <p style={styles.chatHeaderSubtitle}>Expert Team Support</p>
//               </div>
//             </div>
//             <button 
//               style={styles.closeChatBtn}
//               onClick={() => setIsChatOpen(false)}
//             >
//               ✕
//             </button>
//           </div>

//           {/* Quick Replies */}
//           {quickReplies.length > 0 && (
//             <div style={styles.quickReplies}>
//               {quickReplies.map((option, index) => (
//                 <button
//                   key={index}
//                   style={styles.replyBtn}
//                   onClick={() => handleQuickReply(option)}
//                   onMouseEnter={(e) => {
//                     e.target.style.background = '#447793';
//                     e.target.style.color = 'white';
//                     e.target.style.transform = 'translateY(-1px)';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.background = 'white';
//                     e.target.style.color = '#123249';
//                     e.target.style.transform = 'none';
//                   }}
//                 >
//                   {option}
//                 </button>
//               ))}
//             </div>
//           )}

//           {/* Chat Messages */}
//           <div style={styles.chatMessages}>
//             {chatMessages.map((msg) => (
//               <div 
//                 key={msg.id} 
//                 style={{
//                   ...styles.message,
//                   ...(msg.sender === 'bot' ? styles.botMessage : styles.userMessage)
//                 }}
//               >
//                 {msg.text}
//                 <span style={styles.messageTime}>{msg.time}</span>
//               </div>
//             ))}
//           </div>

//           {/* Chat Input */}
//           <div style={styles.chatInputArea}>
//             <div style={styles.inputWrapper}>
//               <input
//                 type="text"
//                 value={chatInput}
//                 onChange={(e) => setChatInput(e.target.value)}
//                 onKeyPress={handleKeyPress}
//                 placeholder="Type your message..."
//                 style={styles.chatInput}
//                 onFocus={(e) => e.target.style.borderColor = '#447793'}
//                 onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
//               />
//               <button 
//                 style={styles.sendBtn}
//                 onClick={handleChatSend}
//                 onMouseEnter={(e) => {
//                   e.target.style.background = 'linear-gradient(135deg, #2D5A74, #123249)';
//                   e.target.style.transform = 'scale(1.05)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.background = 'linear-gradient(135deg, #447793, #2D5A74)';
//                   e.target.style.transform = 'scale(1)';
//                 }}
//               >
//                 📤
//               </button>
//             </div>
//             <p style={styles.footerText}>Powered by Blue Sky Energy</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Team;



















import React, { useState, useEffect, useRef } from 'react';

const Team = () => {
  const [hoveredTeamMember, setHoveredTeamMember] = useState(null);
  const [hoveredTestimonial, setHoveredTestimonial] = useState(null);
  const [activeFAQ, setActiveFAQ] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeService, setActiveService] = useState(0);
  const testimonialRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  
  // Chatbot states
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState('');
  const [leadCaptured, setLeadCaptured] = useState(false);
  const [awaitingLeadInfo, setAwaitingLeadInfo] = useState(false);
  const [leadStep, setLeadStep] = useState(0);
  const [userData, setUserData] = useState({ name: '', phone: '', city: '' });
  const [messageCount, setMessageCount] = useState(0);
  const [quickReplies, setQuickReplies] = useState([]);
  const [chatbotHover, setChatbotHover] = useState(false);

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Initialize chat when opened
  useEffect(() => {
    if (isChatOpen && chatMessages.length === 0) {
      initChat();
    }
  }, [isChatOpen]);

  // Testimonials data with auto-scroll
  const testimonials = [
    {
      id: 1,
      name: "Vinit Tembare",
      role: "Homeowner, Nagpur",
      text: "I recently installed solar panels from Blue Sky Energy and couldn't be happier with the results. My electricity bills have reduced by 80%! The team was professional, efficient, and guided me through every step.",
      rating: 5,
      image: require('./images/customer6.jpeg'),
      savings: "80% bill reduction",
      system: "5kW Solar System",
      date: "6 months ago"
    },
    {
      id: 2,
      name: "Sangita Banait",
      role: "Business Owner, Akola",
      text: "As a small business owner, switching to solar was the best decision I made. Blue Sky Energy's commercial solution helped me save ₹3.5 lakhs annually. Their after-sales service is exceptional!",
      rating: 5,
      image: require('./images/customer5.jpeg'),
      savings: "₹3.5L annual savings",
      system: "40kW Commercial System",
      date: "1 year ago"
    },
    {
      id: 3,
      name: "Sumit Hedaoo",
      role: "Factory Manager, Amravati",
      text: "Our manufacturing plant reduced energy costs by 68% after installing Blue Sky Energy's 500kW system. The ROI was faster than expected, and we're proud to be more environmentally responsible.",
      rating: 5,
      image: require('./images/customer4.jpeg'),
      savings: "68% cost reduction",
      system: "500kW Industrial System",
      date: "8 months ago"
    },
    {
      id: 4,
      name: "Chaksuka Kindarle",
      role: "Residential Client, Bhandara",
      text: "The solar installation process was seamless. From consultation to activation, Blue Sky Energy team was transparent and professional. We're now generating surplus energy that we sell back to the grid!",
      rating: 5,
      image: require('./images/customer3.jpeg'),
      savings: "Net metering benefits",
      system: "8kW Home System",
      date: "3 months ago"
    }
  ];

  // Team members data
  const teamMembers = [
    {
      id: 1,
      name: "Lokesh Karemore",
      role: "Solar Technology Expert",
      bio: "15+ years in renewable energy. Specializes in photovoltaic systems and energy storage solutions.",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
      expertise: ["PV Systems", "Battery Storage", "Grid Integration"]
    },
    {
      id: 2,
      name: "Anikesh Karemore",
      role: "Project Director",
      bio: "Leads our largest commercial and industrial solar projects. 12 years in renewable energy sector.",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
      expertise: ["Project Management", "Commercial Installations", "Client Relations"]
    },
    {
      id: 3,
      name: "Akshay Sahare",
      role: "Installation Manager",
      bio: "Oversees all residential and commercial installations. Certified solar installer with 10+ years experience.",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
      expertise: ["Installation", "Quality Control", "Safety Standards"]
    },
  ];

  // FAQ Data
  const faqs = [
    {
      id: 1,
      question: "How long does solar panel installation take?",
      answer: "Typically, residential installations take 1-3 days, while commercial projects may take 2-4 weeks depending on scale. We complete most installations within the promised timeframe with minimal disruption.",
      category: "Installation"
    },
    {
      id: 2,
      question: "Do solar panels work during monsoon/cloudy days?",
      answer: "Yes! Modern solar panels work at 10-25% efficiency even on cloudy days. During monsoon, you'll still generate significant power, and our systems include battery storage for continuous supply.",
      category: "Performance"
    },
    {
      id: 3,
      question: "What maintenance do solar panels require?",
      answer: "Solar panels require minimal maintenance. We recommend cleaning them twice a year and annual professional inspection. Our maintenance packages start at ₹2,999/year.",
      category: "Maintenance"
    },
    {
      id: 4,
      question: "Are there government subsidies available?",
      answer: "Yes! You can avail up to 40% subsidy on residential solar installations through government schemes. We help you with all documentation and approval processes.",
      category: "Financial"
    },
    {
      id: 5,
      question: "What is the lifespan of solar panels?",
      answer: "Most solar panels come with 25-year performance warranties and can last 30+ years with proper maintenance. We use Tier-1 panels with the longest warranties in the industry.",
      category: "Performance"
    }
  ];

  // Services Data
  const services = [
    {
      id: 1,
      title: "Residential Solar Solutions",
      description: "Complete solar systems for homes, apartments, and villas with net metering.",
      icon: "🏠",
      image: require('./images/service (2).jpg')
    },
    {
      id: 2,
      title: "Commercial Solar Systems",
      description: "Custom solar solutions for businesses, factories, and commercial complexes.",
      icon: "🏢",
      image: require('./images/service.jpg')
    },
    {
      id: 3,
      title: "Solar Water Pumping",
      description: "Agricultural and domestic solar water pumping systems for remote areas.",
      icon: "💧",
      image: require('./images/service3.jpg')
    },
  ];

  // Process Steps
  const processSteps = [
    {
      id: 1,
      title: "Consultation & Assessment",
      description: "Free site survey and energy analysis",
      icon: "📞"
    },
    {
      id: 2,
      title: "Custom Design & Proposal",
      description: "Tailored solar system design and quotation",
      icon: "📐"
    },
    {
      id: 3,
      title: "Installation",
      description: "Professional installation by certified technicians",
      icon: "🔧"
    },
    {
      id: 4,
      title: "Activation & Support",
      description: "System activation and ongoing maintenance",
      icon: "⚡"
    }
  ];

  // Auto-scroll testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      if (!hoveredTestimonial) {
        setCurrentSlide((prev) => (prev + 1) % testimonials.length);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length, hoveredTestimonial]);

  // Auto-rotate services
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveService((prev) => (prev + 1) % services.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [services.length]);

  // Chatbot functions
  const initChat = () => {
    addChatMessage("Hi 👋 Welcome to Blue Sky Energy! How can we help you with our team and services today?", 'bot');
    setTimeout(() => {
      addChatMessage("Choose an option to get started:", 'bot');
      setQuickReplies([
        "👥 Meet Our Team", 
        "🛠️ Our Services", 
        "📞 Contact Experts",
        "💬 Customer Support"
      ]);
    }, 800);
  };

  const addChatMessage = (text, sender) => {
    const time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const newMessage = {
      text,
      sender,
      time,
      id: Date.now()
    };
    setChatMessages(prev => [...prev, newMessage]);
    if (sender === 'user') {
      setMessageCount(prev => prev + 1);
    }
  };

  // Keyword Logic for Team/Services
  const matchKeywords = (input) => {
    const text = input.toLowerCase();
    if (text.includes('team') || text.includes('expert') || text.includes('staff')) {
      return "👥 Our Expert Team\n\n• Lokesh Karemore - Solar Technology Expert\n• Anikesh Karemore - Project Director\n• Akshay Sahare - Installation Manager\n\n5000+ projects completed, 98% satisfaction rate. Want to know more about our team?";
    }
    if (text.includes('service') || text.includes('solution') || text.includes('offer')) {
      return "🛠️ Our Services\n\n• Residential Solar Solutions (Homes & Villas)\n• Commercial Solar Systems (Businesses & Factories)\n• Solar Water Pumping (Agriculture)\n• Industrial Solar Projects\n• Maintenance & Support\n\nWhich service are you interested in?";
    }
    if (text.includes('contact') || text.includes('call') || text.includes('talk')) {
      return "📞 Contact Our Experts\n\n• Call: +91 80879 32436\n• Email: info@blueskyenergy.in\n• Hours: Sun-Sat 9:30 AM - 9:00 PM\n• Address: Plot.No 62A, Umred Rd, Nagpur\n\nWant to schedule a free consultation?";
    }
    if (text.includes('support') || text.includes('help') || text.includes('assistance')) {
      return "💬 Customer Support\n\n• 24/7 Technical Support\n• Annual Maintenance Plans\n• Emergency Repairs\n• Performance Monitoring\n• Warranty Claims\n\nHow can we assist you today?";
    }
    if (text.includes('installation') || text.includes('install') || text.includes('process')) {
      return "🔧 Our 4-Step Process\n\n1. Free Consultation & Assessment\n2. Custom Design & Proposal\n3. Professional Installation\n4. Activation & Ongoing Support\n\nAll projects completed within promised timeframe. Want process details?";
    }
    if (text.includes('experience') || text.includes('year') || text.includes('expertise')) {
      return "🏆 Our Expertise\n\n• 10+ Years Experience\n• 5000+ Projects Completed\n• 98% Customer Satisfaction\n• Certified Solar Installers\n• Tier-1 Solar Panels\n\nWe guarantee on-time completion and 100% satisfaction!";
    }
    if (text.includes('testimonial') || text.includes('review') || text.includes('feedback')) {
      return "⭐ Customer Feedback\n\n\"My electricity bills reduced by 80%!\" - Vinit Tembare, Nagpur\n\"Saved ₹3.5 lakhs annually!\" - Sangita Banait, Akola\n\"Professional team, seamless installation!\" - Sumit Hedaoo, Amravati\n\nWant to see more testimonials?";
    }
    if (text.includes('faq') || text.includes('question') || text.includes('answer')) {
      return "❓ Common Questions\n\n• Installation takes 1-3 days\n• Works on cloudy days (10-25% efficiency)\n• Minimal maintenance required\n• 40% government subsidies available\n• 25+ years lifespan\n\nHave a specific question?";
    }
    return "I understand you're interested in our team and services! I can help you connect with our experts, learn about our services, get installation details, or answer any questions you have.";
  };

  // Lead Capture Logic
  const handleLeadCapture = (input) => {
    if (leadStep === 0) {
      setUserData(prev => ({ ...prev, name: input }));
      setLeadStep(1);
      addChatMessage(`Nice to meet you, ${input}! 😊\n\nCould you please share your phone number?`, 'bot');
    } else if (leadStep === 1) {
      setUserData(prev => ({ ...prev, phone: input }));
      setLeadStep(2);
      addChatMessage("Great! And which city are you from?", 'bot');
    } else if (leadStep === 2) {
      setUserData(prev => ({ ...prev, city: input }));
      setLeadCaptured(true);
      setAwaitingLeadInfo(false);
      saveLead({ ...userData, city: input });
      addChatMessage(`Perfect! Thank you ${userData.name}! ✅\n\nOur team expert will contact you within 24 hours. You'll be connected with Lokesh, Anikesh, or Akshay based on your needs.`, 'bot');
    }
  };

  const saveLead = (data) => {
    const leadId = `lead_${Date.now()}`;
    localStorage.setItem(leadId, JSON.stringify({...data, timestamp: new Date()}));
    console.log("Team Page Lead Saved:", data);
  };

  const handleChatSend = () => {
    const text = chatInput.trim();
    if (!text) return;

    addChatMessage(text, 'user');
    setChatInput('');
    setQuickReplies([]);

    setTimeout(() => {
      if (awaitingLeadInfo) {
        handleLeadCapture(text);
      } else {
        const response = matchKeywords(text);
        addChatMessage(response, 'bot');

        // Trigger Lead Capture after 2 interactions
        if (!leadCaptured && messageCount >= 1) {
          setTimeout(() => {
            addChatMessage("I'd love to connect you with our team! 📋\n\nCan I get your name to assist you better?", 'bot');
            setAwaitingLeadInfo(true);
          }, 1500);
        }
      }
    }, 600);
  };

  const handleQuickReply = (option) => {
    setChatInput(option);
    setTimeout(() => {
      handleChatSend();
    }, 100);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleChatSend();
    }
  };

  // Handle testimonial hover - Instagram Style
  const handleTestimonialMouseEnter = (index) => {
    setHoveredTestimonial(index);
    setCurrentSlide(index);
  };

  const handleTestimonialMouseLeave = () => {
    setHoveredTestimonial(null);
  };

  // Responsive Styles
  const getResponsiveStyle = (desktopStyle, mobileStyle) => {
    return isMobile ? { ...desktopStyle, ...mobileStyle } : desktopStyle;
  };

  const styles = {
    container: {
      fontFamily: "Cambria, serif",
      backgroundColor: '#ffffff',
      minHeight: '100vh',
      color: '#123249',
      overflowX: 'hidden',
      position: 'relative',
      width: '100%'
    },
    
    // Chatbot Styles - Blue Theme
    chatbotContainer: {
      position: 'fixed',
      bottom: isMobile ? '10px' : '20px',
      right: isMobile ? '10px' : '20px',
      zIndex: '9999',
      fontFamily: "Cambria, serif"
    },
    chatToggleBtn: {
      position: 'fixed',
      bottom: isMobile ? '10px' : '20px',
      right: isMobile ? '10px' : '20px',
      width: isMobile ? '50px' : '60px',
      height: isMobile ? '50px' : '60px',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #447793, #2D5A74)',
      color: 'white',
      border: 'none',
      fontSize: isMobile ? '20px' : '24px',
      cursor: 'pointer',
      boxShadow: '0 8px 30px rgba(68, 119, 147, 0.3)',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: '10000',
      padding: '0',
      animation: chatbotHover ? 'pulse 0.5s infinite' : 'pulse 2s infinite'
    },
    chatWindow: {
      position: 'fixed',
      bottom: isMobile ? '70px' : '90px',
      right: isMobile ? '10px' : '20px',
      width: isMobile ? 'calc(100vw - 20px)' : '380px',
      maxWidth: isMobile ? 'calc(100vw - 20px)' : 'calc(100vw - 40px)',
      height: isMobile ? '60vh' : '550px',
      maxHeight: isMobile ? '60vh' : '70vh',
      background: 'white',
      borderRadius: '16px',
      boxShadow: '0 10px 40px rgba(6, 18, 33, 0.15)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      zIndex: '9999',
      transition: 'all 0.3s ease',
      opacity: isChatOpen ? '1' : '0',
      visibility: isChatOpen ? 'visible' : 'hidden',
      transform: isChatOpen ? 'translateY(0)' : 'translateY(20px)',
      border: '1px solid #DDE8ED'
    },
    chatHeader: {
      background: 'linear-gradient(135deg, #447793, #2D5A74)',
      color: 'white',
      padding: isMobile ? '12px' : '16px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
    },
    headerInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: isMobile ? '8px' : '12px'
    },
    headerIcon: {
      background: 'rgba(255, 255, 255, 0.2)',
      padding: isMobile ? '8px' : '10px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: isMobile ? '35px' : '40px',
      height: isMobile ? '35px' : '40px',
      fontSize: isMobile ? '16px' : '18px'
    },
    chatHeaderTitle: {
      margin: '0',
      fontSize: isMobile ? '14px' : '16px',
      fontWeight: '600',
      lineHeight: '1.2',
      color: 'white'
    },
    chatHeaderSubtitle: {
      margin: '0',
      fontSize: isMobile ? '10px' : '12px',
      opacity: '0.9',
      lineHeight: '1.2',
      color: '#DDE8ED'
    },
    closeChatBtn: {
      background: 'none',
      border: 'none',
      color: 'white',
      cursor: 'pointer',
      fontSize: isMobile ? '16px' : '18px',
      padding: '5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'opacity 0.2s'
    },
    quickReplies: {
      padding: isMobile ? '8px' : '12px',
      display: 'flex',
      flexWrap: 'wrap',
      gap: isMobile ? '6px' : '8px',
      background: '#DDE8ED',
      borderBottom: '1px solid #DDE8ED',
      maxHeight: isMobile ? '80px' : 'none',
      overflowY: 'auto'
    },
    replyBtn: {
      background: 'white',
      border: '1px solid #447793',
      color: '#123249',
      padding: isMobile ? '6px 12px' : '8px 16px',
      borderRadius: '20px',
      fontSize: isMobile ? '12px' : '13px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      whiteSpace: 'nowrap',
      fontWeight: '500',
      fontFamily: "Cambria, serif",
      flexShrink: '0'
    },
    chatMessages: {
      flex: '1',
      padding: isMobile ? '12px' : '16px',
      background: '#DDE8ED',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      gap: isMobile ? '8px' : '12px'
    },
    message: {
      maxWidth: isMobile ? '90%' : '80%',
      padding: isMobile ? '10px 12px' : '12px 16px',
      borderRadius: '18px',
      fontSize: isMobile ? '13px' : '14px',
      lineHeight: '1.5',
      whiteSpace: 'pre-line',
      wordWrap: 'break-word',
      position: 'relative',
      animation: 'fadeIn 0.3s ease'
    },
    botMessage: {
      background: 'white',
      alignSelf: 'flex-start',
      borderBottomLeftRadius: '4px',
      boxShadow: '0 2px 8px rgba(6, 18, 33, 0.08)',
      color: '#123249',
      border: '1px solid #DDE8ED'
    },
    userMessage: {
      background: 'linear-gradient(135deg, #447793, #2D5A74)',
      color: 'white',
      alignSelf: 'flex-end',
      borderBottomRightRadius: '4px'
    },
    messageTime: {
      fontSize: isMobile ? '10px' : '11px',
      marginTop: '6px',
      display: 'block',
      opacity: '0.7'
    },
    chatInputArea: {
      padding: isMobile ? '12px' : '16px',
      borderTop: '1px solid #DDE8ED',
      background: 'white'
    },
    inputWrapper: {
      display: 'flex',
      gap: isMobile ? '8px' : '10px',
      marginBottom: isMobile ? '6px' : '8px'
    },
    chatInput: {
      flex: '1',
      padding: isMobile ? '10px 14px' : '12px 16px',
      border: '1px solid #DDE8ED',
      borderRadius: '25px',
      outline: 'none',
      fontSize: isMobile ? '13px' : '14px',
      fontFamily: "Cambria, serif",
      transition: 'border-color 0.2s',
      color: '#123249'
    },
    sendBtn: {
      background: 'linear-gradient(135deg, #447793, #2D5A74)',
      color: 'white',
      border: 'none',
      width: isMobile ? '40px' : '45px',
      height: isMobile ? '40px' : '45px',
      borderRadius: '50%',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: isMobile ? '14px' : '16px',
      transition: 'all 0.2s ease',
      padding: '0'
    },
    footerText: {
      textAlign: 'center',
      fontSize: isMobile ? '10px' : '11px',
      color: '#2D5A74',
      margin: '0'
    },
    
    // Hero Section - Blue Theme
    heroSection: {
      background: 'linear-gradient(rgba(18, 50, 73, 0.95), rgba(45, 90, 116, 0.95))',
      color: 'white',
      padding: isMobile ? '80px 20px 40px' : '120px 20px 80px',
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden'
    },
    heroTitle: {
      fontSize: isMobile ? '2rem' : '3.5rem',
      fontWeight: '800',
      marginBottom: isMobile ? '15px' : '20px',
      textShadow: '2px 2px 4px rgba(6, 18, 33, 0.1)',
      lineHeight: isMobile ? '1.2' : '1.3',
      color: 'white'
    },
    heroSubtitle: {
      fontSize: isMobile ? '1rem' : '1.3rem',
      maxWidth: '800px',
      margin: '0 auto',
      marginBottom: isMobile ? '30px' : '40px',
      opacity: '0.95',
      lineHeight: '1.6',
      padding: isMobile ? '0 10px' : '0',
      color: '#DDE8ED'
    },
    heroStats: {
      display: 'flex',
      justifyContent: 'center',
      gap: isMobile ? '20px' : '60px',
      marginTop: isMobile ? '30px' : '40px',
      flexWrap: 'wrap'
    },
    statItem: {
      textAlign: 'center',
      flex: isMobile ? '1 0 40%' : 'none',
      marginBottom: isMobile ? '15px' : '0'
    },
    statNumber: {
      fontSize: isMobile ? '2rem' : '3rem',
      fontWeight: '800',
      marginBottom: '5px',
      color: '#DDE8ED'
    },
    statLabel: {
      fontSize: isMobile ? '0.9rem' : '1rem',
      opacity: '0.9',
      color: 'white'
    },
    
    // Main Content Container
    mainContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: isMobile ? '40px 20px' : '60px 20px'
    },
    
    // Section Headers - Blue Theme
    sectionHeader: {
      textAlign: 'center',
      marginBottom: isMobile ? '40px' : '60px',
      padding: isMobile ? '0 10px' : '0'
    },
    sectionTitle: {
      fontSize: isMobile ? '1.8rem' : '2.5rem',
      fontWeight: '800',
      color: '#123249',
      marginBottom: isMobile ? '10px' : '15px',
      lineHeight: isMobile ? '1.2' : '1.3'
    },
    sectionSubtitle: {
      fontSize: isMobile ? '1rem' : '1.1rem',
      color: '#2D5A74',
      maxWidth: '800px',
      margin: '0 auto',
      lineHeight: '1.6',
      padding: isMobile ? '0 10px' : '0'
    },
    
    // About Section - Blue Theme
    aboutSection: {
      backgroundColor: '#DDE8ED',
      padding: isMobile ? '40px 20px' : '80px 20px',
      marginTop: isMobile ? '20px' : '40px'
    },
    aboutContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
      gap: isMobile ? '40px' : '60px',
      alignItems: 'center'
    },
    aboutContent: {
      paddingRight: isMobile ? '0' : '40px'
    },
    aboutTitle: {
      fontSize: isMobile ? '1.8rem' : '2.2rem',
      fontWeight: '800',
      color: '#123249',
      marginBottom: isMobile ? '15px' : '20px'
    },
    aboutText: {
      color: '#2D5A74',
      fontSize: isMobile ? '0.95rem' : '1rem',
      lineHeight: '1.7',
      marginBottom: isMobile ? '20px' : '25px'
    },
    featuresList: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
      gap: isMobile ? '15px' : '20px',
      marginTop: isMobile ? '20px' : '30px'
    },
    featureItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: isMobile ? '10px' : '15px'
    },
    featureIcon: {
      color: '#447793',
      fontSize: isMobile ? '1.2rem' : '1.5rem'
    },
    featureText: {
      color: '#2D5A74',
      fontSize: isMobile ? '0.9rem' : '0.95rem',
      lineHeight: '1.6'
    },
    
    // Team Section - Blue Theme
    teamSection: {
      padding: isMobile ? '40px 20px' : '80px 20px'
    },
    teamGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: isMobile ? '20px' : '30px',
      marginTop: isMobile ? '30px' : '40px'
    },
    teamCard: {
      backgroundColor: 'white',
      borderRadius: isMobile ? '10px' : '15px',
      overflow: 'hidden',
      boxShadow: '0 10px 30px rgba(6, 18, 33, 0.08)',
      transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
      position: 'relative',
      cursor: 'pointer',
      border: '1px solid #DDE8ED'
    },
    teamImage: {
      width: '100%',
      height: isMobile ? '250px' : '300px',
      objectFit: 'cover',
      transition: 'transform 0.5s ease'
    },
    teamContent: {
      padding: isMobile ? '20px' : '25px'
    },
    teamName: {
      fontSize: isMobile ? '1.2rem' : '1.4rem',
      fontWeight: '700',
      color: '#123249',
      marginBottom: isMobile ? '6px' : '8px'
    },
    teamRole: {
      color: '#447793',
      fontSize: isMobile ? '0.85rem' : '0.95rem',
      fontWeight: '600',
      marginBottom: isMobile ? '12px' : '15px'
    },
    teamBio: {
      color: '#2D5A74',
      fontSize: isMobile ? '0.85rem' : '0.9rem',
      lineHeight: '1.6',
      marginBottom: isMobile ? '15px' : '20px'
    },
    expertiseContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      marginTop: isMobile ? '12px' : '15px'
    },
    expertiseTag: {
      backgroundColor: '#DDE8ED',
      color: '#123249',
      padding: isMobile ? '3px 10px' : '4px 12px',
      borderRadius: '15px',
      fontSize: isMobile ? '0.7rem' : '0.75rem',
      fontWeight: '500'
    },
    
    // Process Section - Blue Theme
    processSection: {
      backgroundColor: '#DDE8ED',
      padding: isMobile ? '40px 20px' : '80px 20px'
    },
    processContainer: {
      maxWidth: '1200px',
      margin: '0 auto'
    },
    processStepsContainer: {
      display: isMobile ? 'flex' : 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginTop: isMobile ? '30px' : '50px',
      position: 'relative',
      gap: isMobile ? '30px' : '0'
    },
    processStep: {
      textAlign: 'center',
      flex: isMobile ? '1' : '1',
      padding: isMobile ? '0' : '0 20px',
      position: 'relative'
    },
    stepIcon: {
      width: isMobile ? '60px' : '80px',
      height: isMobile ? '60px' : '80px',
      backgroundColor: '#447793',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto',
      marginBottom: isMobile ? '15px' : '20px',
      fontSize: isMobile ? '1.5rem' : '2rem',
      color: 'white',
      boxShadow: '0 10px 20px rgba(68, 119, 147, 0.3)'
    },
    stepTitle: {
      fontSize: isMobile ? '1.1rem' : '1.2rem',
      fontWeight: '700',
      color: '#123249',
      marginBottom: isMobile ? '8px' : '10px'
    },
    stepDescription: {
      color: '#2D5A74',
      fontSize: isMobile ? '0.85rem' : '0.9rem',
      lineHeight: '1.6'
    },
    
    // Services Section - Blue Theme
    servicesSection: {
      padding: isMobile ? '40px 20px' : '80px 20px',
      backgroundColor: '#ffffff'
    },
    servicesGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: isMobile ? '20px' : '30px',
      marginTop: isMobile ? '30px' : '40px'
    },
    serviceCard: {
      backgroundColor: 'white',
      borderRadius: isMobile ? '10px' : '15px',
      overflow: 'hidden',
      boxShadow: '0 10px 30px rgba(6, 18, 33, 0.08)',
      transition: 'all 0.4s ease',
      position: 'relative',
      cursor: 'pointer',
      border: '3px solid transparent',
    },
    serviceImage: {
      width: '100%',
      height: isMobile ? '180px' : '200px',
      objectFit: 'cover',
      transition: 'transform 0.5s ease'
    },
    serviceContent: {
      padding: isMobile ? '20px' : '25px'
    },
    serviceIcon: {
      fontSize: isMobile ? '2rem' : '2.5rem',
      marginBottom: isMobile ? '12px' : '15px'
    },
    serviceTitle: {
      fontSize: isMobile ? '1.2rem' : '1.3rem',
      fontWeight: '700',
      color: '#123249',
      marginBottom: isMobile ? '8px' : '10px'
    },
    serviceDescription: {
      color: '#2D5A74',
      fontSize: isMobile ? '0.9rem' : '0.95rem',
      lineHeight: '1.6',
      marginBottom: isMobile ? '15px' : '20px'
    },
    learnMore: {
      color: '#447793',
      fontWeight: '600',
      textDecoration: 'none',
      fontSize: isMobile ? '0.9rem' : '0.95rem',
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      transition: 'all 0.3s ease'
    },
    
    // Testimonials Section - Blue Theme - INSTAGRAM STYLE PROFILE VIEW
    testimonialsSection: {
      background: 'linear-gradient(rgba(18, 50, 73, 0.95), rgba(45, 90, 116, 0.95))',
      padding: isMobile ? '40px 20px' : '80px 20px',
      color: 'white'
    },
    testimonialSlider: {
      maxWidth: '800px',
      margin: isMobile ? '30px auto 0' : '40px auto 0',
      position: 'relative',
      minHeight: isMobile ? '450px' : '400px'
    },
    testimonialCard: {
      backgroundColor: '#ffffff',
      borderRadius: isMobile ? '10px' : '15px',
      padding: isMobile ? '25px' : '40px',
      textAlign: 'center',
      minHeight: isMobile ? '450px' : '400px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      border: '1px solid #DDE8ED',
      transition: 'all 0.3s ease',
      position: 'relative',
      overflow: 'visible'
    },
    testimonialRating: {
      fontSize: isMobile ? '1.3rem' : '1.5rem',
      color: '#447793',
      marginBottom: isMobile ? '15px' : '20px'
    },
    testimonialText: {
      fontSize: isMobile ? '1rem' : '1.1rem',
      lineHeight: '1.7',
      marginBottom: isMobile ? '25px' : '30px',
      color: '#123249',
      fontStyle: 'italic',
      maxWidth: '600px',
      margin: '0 auto 30px'
    },
    testimonialAuthor: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      position: 'relative',
      width: '100%'
    },
    // Instagram Style Profile Image Container
    profileContainer: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '15px',
      cursor: 'pointer',
      zIndex: 5
    },
    profileImage: {
      width: isMobile ? '80px' : '100px',
      height: isMobile ? '80px' : '100px',
      borderRadius: '50%',
      objectFit: 'cover',
      border: '4px solid #447793',
      transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
      cursor: 'pointer',
      boxShadow: '0 5px 15px rgba(0,0,0,0.1)'
    },
    profileImageHovered: {
      width: isMobile ? '180px' : '250px',
      height: isMobile ? '180px' : '250px',
      border: '6px solid #447793',
      boxShadow: '0 20px 40px rgba(68, 119, 147, 0.4)',
      transform: 'scale(1.05)',
      zIndex: 20,
      position: 'relative',
      marginBottom: '20px'
    },
    // Instagram Style Info Popup - Center Below Image
    profileInfoPopup: {
      position: 'absolute',
      top: isMobile ? '190px' : '270px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: '#123249',
      color: 'white',
      padding: isMobile ? '12px 20px' : '15px 30px',
      borderRadius: '12px',
      fontSize: isMobile ? '0.9rem' : '1rem',
      fontWeight: '600',
      boxShadow: '0 15px 30px rgba(0,0,0,0.3)',
      zIndex: 30,
      animation: 'slideUpFade 0.4s ease',
      border: '2px solid #447793',
      minWidth: isMobile ? '200px' : '280px',
      textAlign: 'center'
    },
    infoRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      marginBottom: '8px'
    },
    infoIcon: {
      fontSize: '1.2rem',
      color: '#DDE8ED'
    },
    infoText: {
      color: 'white',
      fontWeight: '500'
    },
    authorName: {
      fontSize: isMobile ? '1.2rem' : '1.3rem',
      fontWeight: '700',
      marginBottom: '5px',
      color: '#123249',
      marginTop: '10px'
    },
    authorRole: {
      color: '#2D5A74',
      fontSize: isMobile ? '0.9rem' : '1rem',
      opacity: '0.9',
      fontWeight: '500'
    },
    sliderDots: {
      display: 'flex',
      justifyContent: 'center',
      gap: isMobile ? '8px' : '10px',
      marginTop: isMobile ? '25px' : '30px'
    },
    dot: {
      width: isMobile ? '10px' : '12px',
      height: isMobile ? '10px' : '12px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255,255,255,0.3)',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    },
    activeDot: {
      backgroundColor: '#447793',
      transform: 'scale(1.2)'
    },
    
    // FAQ Section - Blue Theme
    faqSection: {
      padding: isMobile ? '40px 20px' : '80px 20px',
      backgroundColor: '#ffffff'
    },
    faqContainer: {
      maxWidth: '800px',
      margin: isMobile ? '30px auto 0' : '40px auto 0'
    },
    faqItem: {
      backgroundColor: '#DDE8ED',
      borderRadius: isMobile ? '8px' : '10px',
      marginBottom: isMobile ? '12px' : '15px',
      overflow: 'hidden',
      border: '2px solid #DDE8ED',
      transition: 'all 0.3s ease'
    },
    faqQuestion: {
      padding: isMobile ? '15px 20px' : '20px 25px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      cursor: 'pointer',
      backgroundColor: 'white',
      flexDirection: isMobile ? 'column' : 'row',
      gap: isMobile ? '10px' : '0',
      alignItems: isMobile ? 'flex-start' : 'center'
    },
    questionText: {
      fontSize: isMobile ? '1rem' : '1.1rem',
      fontWeight: '600',
      color: '#123249',
      display: 'flex',
      alignItems: 'center',
      gap: isMobile ? '10px' : '15px',
      flexWrap: 'wrap'
    },
    questionCategory: {
      backgroundColor: '#DDE8ED',
      color: '#123249',
      padding: isMobile ? '3px 10px' : '4px 12px',
      borderRadius: '15px',
      fontSize: isMobile ? '0.75rem' : '0.8rem',
      fontWeight: '600'
    },
    faqAnswer: {
      padding: '0 25px',
      maxHeight: '0',
      overflow: 'hidden',
      transition: 'all 0.3s ease',
      color: '#2D5A74',
      lineHeight: '1.6',
      fontSize: isMobile ? '0.9rem' : '1rem'
    },
    faqAnswerOpen: {
      padding: isMobile ? '15px 20px' : '20px 25px',
      maxHeight: '500px'
    },
    
    // Mobile-specific styles
    mobileHidden: {
      display: isMobile ? 'none' : 'block'
    },
    mobileOnly: {
      display: isMobile ? 'block' : 'none'
    }
  };

  return (
    <div style={styles.container}>
      {/* Hero Section - Blue Theme */}
      <section style={styles.heroSection}>
        <h1 style={styles.heroTitle}>POWERING FUTURES, BUILDING TRUST</h1>
        <p style={styles.heroSubtitle}>
          We Do Everything Solar For Everyone. With over 10 years of experience in renewable energy, 
          we've helped thousands of homes and businesses transition to clean, affordable solar power.
        </p>
        
        <div style={styles.heroStats}>
          <div style={styles.statItem}>
            <div style={styles.statNumber}>10+</div>
            <div style={styles.statLabel}>Years Experience</div>
          </div>
          <div style={styles.statItem}>
            <div style={styles.statNumber}>5000+</div>
            <div style={styles.statLabel}>Projects Completed</div>
          </div>
          <div style={styles.statItem}>
            <div style={styles.statNumber}>98%</div>
            <div style={styles.statLabel}>Client Satisfaction</div>
          </div>
          <div style={styles.statItem}>
            <div style={styles.statNumber}>24/7</div>
            <div style={styles.statLabel}>Customer Support</div>
          </div>
        </div>
      </section>

      {/* About Section - Blue Theme */}
      <section style={styles.aboutSection}>
        <div style={styles.aboutContainer}>
          <div style={styles.aboutContent}>
            <h2 style={styles.aboutTitle}>ABOUT BLUE SKY ENERGY</h2>
            <h3 style={{
              ...styles.sectionSubtitle, 
              textAlign: 'left', 
              marginBottom: isMobile ? '20px' : '30px',
              fontSize: isMobile ? '1.1rem' : '1.2rem',
              fontWeight: '600'
            }}>
              Who We Are And What We Stand For
            </h3>
            <p style={styles.aboutText}>
              Our team proudly offers an on-time guarantee and a 100% customer satisfaction guarantee. 
              It's why we make sure that our licensed solar technicians are highly trained and fully 
              equipped to meet your diverse solar energy needs.
            </p>
            
            <div style={styles.featuresList}>
              <div style={styles.featureItem}>
                <span style={styles.featureIcon}>✓</span>
                <span style={styles.featureText}>Residential Solar Solutions</span>
              </div>
              <div style={styles.featureItem}>
                <span style={styles.featureIcon}>✓</span>
                <span style={styles.featureText}>Commercial Solar Systems</span>
              </div>
              <div style={styles.featureItem}>
                <span style={styles.featureIcon}>✓</span>
                <span style={styles.featureText}>Industrial Solar Projects</span>
              </div>
              <div style={styles.featureItem}>
                <span style={styles.featureIcon}>✓</span>
                <span style={styles.featureText}>Maintenance & Support</span>
              </div>
            </div>
          </div>
          
          <div>
            <img 
              src="https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80"
              alt="Solar Installation"
              style={{
                width: '100%',
                borderRadius: isMobile ? '10px' : '15px',
                boxShadow: '0 20px 40px rgba(6, 18, 33, 0.1)',
                transition: 'transform 0.5s ease',
                transform: hoveredTeamMember === 'about' ? 'scale(1.05)' : 'scale(1)'
              }}
              onMouseEnter={() => setHoveredTeamMember('about')}
              onMouseLeave={() => setHoveredTeamMember(null)}
            />
          </div>
        </div>
      </section>

      {/* Team Section - Blue Theme */}
      <section style={styles.teamSection}>
        <div style={styles.mainContent}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>Our Expert Team</h2>
            <p style={styles.sectionSubtitle}>
              Meet our team of solar energy experts dedicated to powering your sustainable future
            </p>
          </div>
          
          <div style={styles.teamGrid}>
            {teamMembers.map(member => (
              <div 
                key={member.id} 
                style={{
                  ...styles.teamCard,
                  transform: hoveredTeamMember === member.id && !isMobile ? 'translateY(-15px)' : 'translateY(0)',
                  boxShadow: hoveredTeamMember === member.id && !isMobile ? '0 20px 40px rgba(68, 119, 147, 0.15)' : '0 10px 30px rgba(6, 18, 33, 0.08)'
                }}
                onMouseEnter={() => !isMobile && setHoveredTeamMember(member.id)}
                onMouseLeave={() => !isMobile && setHoveredTeamMember(null)}
                onClick={() => isMobile && setHoveredTeamMember(hoveredTeamMember === member.id ? null : member.id)}
              >
                <img 
                  src={member.image} 
                  alt={member.name}
                  style={{
                    ...styles.teamImage,
                    transform: hoveredTeamMember === member.id ? 'scale(1.1)' : 'scale(1)'
                  }}
                />
                <div style={styles.teamContent}>
                  <h3 style={styles.teamName}>{member.name}</h3>
                  <p style={styles.teamRole}>{member.role}</p>
                  <p style={styles.teamBio}>{member.bio}</p>
                  <div style={styles.expertiseContainer}>
                    {member.expertise.map((skill, index) => (
                      <span key={index} style={styles.expertiseTag}>{skill}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section - Blue Theme */}
      <section style={styles.processSection}>
        <div style={styles.processContainer}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>Our Standard Working Process</h2>
            <p style={styles.sectionSubtitle}>
              From consultation to activation, we follow a proven 4-step process for seamless solar installation
            </p>
          </div>
          
          <div style={styles.processStepsContainer}>
            {processSteps.map(step => (
              <div key={step.id} style={styles.processStep}>
                <div style={styles.stepIcon}>{step.icon}</div>
                <h3 style={styles.stepTitle}>{step.title}</h3>
                <p style={styles.stepDescription}>{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section - Blue Theme */}
      <section style={styles.servicesSection}>
        <div style={styles.mainContent}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>OUR BEST SERVICES</h2>
            <h3 style={{
              ...styles.sectionSubtitle, 
              fontSize: isMobile ? '1.2rem' : '1.4rem', 
              fontWeight: '700', 
              marginBottom: '10px',
              color: '#123249'
            }}>
              See Our Solar Services
            </h3>
            <p style={styles.sectionSubtitle}>
              Our team proudly offers an on-time guarantee and a 100% customer satisfaction guarantee. 
              It's why we make sure that our licensed technicians are highly trained.
            </p>
          </div>
          
          <div style={styles.servicesGrid}>
            {services.map(service => (
              <div 
                key={service.id} 
                style={{
                  ...styles.serviceCard,
                  border: activeService === service.id - 1 ? '3px solid #447793' : '3px solid transparent',
                  transform: hoveredTeamMember === `service-${service.id}` && !isMobile ? 'translateY(-10px)' : 'translateY(0)',
                  boxShadow: hoveredTeamMember === `service-${service.id}` && !isMobile ? '0 20px 40px rgba(68, 119, 147, 0.15)' : '0 10px 30px rgba(6, 18, 33, 0.08)'
                }}
                onMouseEnter={() => !isMobile && setHoveredTeamMember(`service-${service.id}`)}
                onMouseLeave={() => !isMobile && setHoveredTeamMember(null)}
              >
                <img 
                  src={service.image} 
                  alt={service.title}
                  style={{
                    ...styles.serviceImage,
                    transform: hoveredTeamMember === `service-${service.id}` ? 'scale(1.1)' : 'scale(1)'
                  }}
                />
                <div style={styles.serviceContent}>
                  <div style={styles.serviceIcon}>{service.icon}</div>
                  <h3 style={styles.serviceTitle}>{service.title}</h3>
                  <p style={styles.serviceDescription}>{service.description}</p>
                  <a href="#" style={styles.learnMore}>
                    Learn More →
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section - Blue Theme - INSTAGRAM STYLE PROFILE VIEW */}
      <section style={styles.testimonialsSection}>
        <div style={styles.mainContent}>
          <div style={styles.sectionHeader}>
            <h2 style={{...styles.sectionTitle, color: 'white'}}>TESTIMONIALS</h2>
            <h3 style={{...styles.sectionSubtitle, color: '#DDE8ED'}}>
              What People Say About Our Solar Solutions
            </h3>
          </div>
          
          <div style={styles.testimonialSlider}>
            <div style={styles.testimonialCard} ref={testimonialRef}>
              <div style={styles.testimonialRating}>
                {'★'.repeat(testimonials[currentSlide].rating)}
              </div>
              <p style={styles.testimonialText}>
                "{testimonials[currentSlide].text}"
              </p>
              
              {/* Instagram Style Profile Section - CENTERED */}
              <div style={styles.testimonialAuthor}>
                <div 
                  style={styles.profileContainer}
                  onMouseEnter={() => handleTestimonialMouseEnter(currentSlide)}
                  onMouseLeave={handleTestimonialMouseLeave}
                >
                  {/* Profile Image - Grows BIG on hover like Instagram */}
                  <img 
                    src={testimonials[currentSlide].image} 
                    alt={testimonials[currentSlide].name}
                    style={{
                      ...styles.profileImage,
                      ...(hoveredTestimonial === currentSlide ? styles.profileImageHovered : {})
                    }}
                  />
                  
                  {/* Instagram Style Info Popup - CENTERED BELOW IMAGE */}
                  {hoveredTestimonial === currentSlide && (
                    <div style={styles.profileInfoPopup}>
                      <div style={styles.infoRow}>
                        <span style={styles.infoIcon}>💰</span>
                        <span style={styles.infoText}>{testimonials[currentSlide].savings}</span>
                      </div>
                      <div style={styles.infoRow}>
                        <span style={styles.infoIcon}>⚡</span>
                        <span style={styles.infoText}>{testimonials[currentSlide].system}</span>
                      </div>
                      <div style={styles.infoRow}>
                        <span style={styles.infoIcon}>📅</span>
                        <span style={styles.infoText}>{testimonials[currentSlide].date}</span>
                      </div>
                    </div>
                  )}
                </div>
                
                {/* Name and Role - Below Profile */}
                <h4 style={styles.authorName}>{testimonials[currentSlide].name}</h4>
                <p style={styles.authorRole}>{testimonials[currentSlide].role}</p>
              </div>
            </div>
            
            <div style={styles.sliderDots}>
              {testimonials.map((_, index) => (
                <div
                  key={index}
                  style={{
                    ...styles.dot,
                    ...(index === currentSlide ? styles.activeDot : {})
                  }}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section - Blue Theme */}
      <section style={styles.faqSection}>
        <div style={styles.mainContent}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>FREQUENTLY ASKED QUESTIONS</h2>
            <h3 style={{
              ...styles.sectionSubtitle, 
              fontSize: isMobile ? '1.2rem' : '1.4rem', 
              fontWeight: '700', 
              marginBottom: '10px',
              color: '#123249'
            }}>
              You Have Questions, We Have Answers
            </h3>
            <p style={styles.sectionSubtitle}>
              Get answers to the most common questions about solar panel installation, maintenance, 
              and savings. Can't find your answer? Contact our team directly.
            </p>
          </div>
          
          <div style={styles.faqContainer}>
            {faqs.map(faq => (
              <div 
                key={faq.id} 
                style={{
                  ...styles.faqItem,
                  borderColor: activeFAQ === faq.id ? '#447793' : '#DDE8ED'
                }}
              >
                <div 
                  style={styles.faqQuestion}
                  onClick={() => setActiveFAQ(activeFAQ === faq.id ? null : faq.id)}
                >
                  <div style={styles.questionText}>
                    <span style={styles.questionCategory}>{faq.category}</span>
                    {faq.question}
                  </div>
                  <div style={{fontSize: isMobile ? '1.2rem' : '1.5rem', color: '#447793'}}>
                    {activeFAQ === faq.id ? '−' : '+'}
                  </div>
                </div>
                <div 
                  style={{
                    ...styles.faqAnswer,
                    ...(activeFAQ === faq.id ? styles.faqAnswerOpen : {})
                  }}
                >
                  {faq.answer}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Chatbot Component - Blue Theme */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          
          @keyframes slideUpFade {
            from { opacity: 0; transform: translateX(-50%) translateY(20px); }
            to { opacity: 1; transform: translateX(-50%) translateY(0); }
          }
          
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
          
          /* Mobile responsiveness fixes */
          @media (max-width: 768px) {
            .testimonial-card {
              min-height: 450px;
              padding: 20px;
            }
            
            .hero-title {
              font-size: 2rem;
              padding: 0 10px;
            }
            
            .hero-subtitle {
              font-size: 1rem;
              padding: 0 15px;
            }
            
            .section-title {
              font-size: 1.8rem;
            }
            
            .stat-number {
              font-size: 1.8rem;
            }
            
            .stat-label {
              font-size: 0.85rem;
            }
            
            .hero-stats {
              gap: 15px;
            }
            
            .team-card {
              margin: 0 10px;
            }
          }
          
          @media (max-width: 480px) {
            .hero-title {
              font-size: 1.8rem;
            }
            
            .section-title {
              font-size: 1.6rem;
            }
            
            .about-title {
              font-size: 1.6rem;
            }
            
            .faq-question {
              padding: 12px 15px;
            }
            
            .testimonial-text {
              font-size: 0.95rem;
            }
          }
          
          /* Custom scrollbar for chat */
          ::-webkit-scrollbar {
            width: 6px;
          }
          
          ::-webkit-scrollbar-track {
            background: #DDE8ED;
          }
          
          ::-webkit-scrollbar-thumb {
            background: #447793;
            border-radius: 3px;
          }
          
          ::-webkit-scrollbar-thumb:hover {
            background: #2D5A74;
          }
          
          /* Prevent text selection on mobile */
          * {
            -webkit-tap-highlight-color: transparent;
          }
          
          /* Improve touch targets */
          button, 
          a, 
          .team-card, 
          .service-card, 
          .faq-item {
            cursor: pointer;
          }
          
          /* Smooth scrolling */
          html {
            scroll-behavior: smooth;
          }
          
          /* Hover Effects */
          .team-card:hover .expertise-tag {
            background-color: #447793 !important;
            color: white !important;
          }
          
          .service-card:hover .learn-more {
            color: #2D5A74 !important;
            gap: 10px !important;
          }
          
          .faq-item:hover {
            border-color: #447793 !important;
          }
        `}
      </style>

      <div style={styles.chatbotContainer}>
        {/* Chat Toggle Button */}
        <button 
          style={styles.chatToggleBtn}
          onClick={() => setIsChatOpen(!isChatOpen)}
          onMouseEnter={() => setChatbotHover(true)}
          onMouseLeave={() => setChatbotHover(false)}
        >
          💬
        </button>

        {/* Chat Window */}
        <div style={styles.chatWindow}>
          {/* Chat Header */}
          <div style={styles.chatHeader}>
            <div style={styles.headerInfo}>
              <div style={styles.headerIcon}>
                👥
              </div>
              <div>
                <h3 style={styles.chatHeaderTitle}>Blue Sky Energy</h3>
                <p style={styles.chatHeaderSubtitle}>Expert Team Support</p>
              </div>
            </div>
            <button 
              style={styles.closeChatBtn}
              onClick={() => setIsChatOpen(false)}
            >
              ✕
            </button>
          </div>

          {/* Quick Replies */}
          {quickReplies.length > 0 && (
            <div style={styles.quickReplies}>
              {quickReplies.map((option, index) => (
                <button
                  key={index}
                  style={styles.replyBtn}
                  onClick={() => handleQuickReply(option)}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#447793';
                    e.target.style.color = 'white';
                    e.target.style.transform = 'translateY(-1px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'white';
                    e.target.style.color = '#123249';
                    e.target.style.transform = 'none';
                  }}
                >
                  {option}
                </button>
              ))}
            </div>
          )}

          {/* Chat Messages */}
          <div style={styles.chatMessages}>
            {chatMessages.map((msg) => (
              <div 
                key={msg.id} 
                style={{
                  ...styles.message,
                  ...(msg.sender === 'bot' ? styles.botMessage : styles.userMessage)
                }}
              >
                {msg.text}
                <span style={styles.messageTime}>{msg.time}</span>
              </div>
            ))}
          </div>

          {/* Chat Input */}
          <div style={styles.chatInputArea}>
            <div style={styles.inputWrapper}>
              <input
                type="text"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Type your message..."
                style={styles.chatInput}
                onFocus={(e) => e.target.style.borderColor = '#447793'}
                onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
              />
              <button 
                style={styles.sendBtn}
                onClick={handleChatSend}
                onMouseEnter={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #2D5A74, #123249)';
                  e.target.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #447793, #2D5A74)';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                📤
              </button>
            </div>
            <p style={styles.footerText}>Powered by Blue Sky Energy</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;